module.exports = __webpack_public_path__ + "img/icon_2_46.ef70a6be.png";